import * as React from 'react';
import { useTranslation } from 'react-i18next';
import SelectionComponent from './SelectionComponent';

export interface YesNoComponentProps {
  handleClick: (answer: boolean) => void;
  id: string;
}

const YesNoComponent: React.FC<YesNoComponentProps> = ({ handleClick, id }) => {
  const { t } = useTranslation();
  const answers = [
    { title: t('home.input.dialog.yes'), key: true },
    { title: t('home.input.dialog.no'), key: false },
    { title: t('home.input.dialog.unknown'), key: null },
  ];
  return <SelectionComponent answers={answers} handleClick={handleClick} id={id} />;
};

export default YesNoComponent;
